<script>
export default {
  props: {
    id: {
      type: String,
    },
    value: {
      type: Number,
    },
  },
  data() {
    return {
      quantity: 0,
    }
  },
  methods: {
    Increment() {
      this.quantity = this.quantity + 1
      this.$emit('input', this.quantity)
    },
    Decrement() {
      if (this.quantity > 0) {
        this.quantity = this.quantity - 1
        this.$emit('input', this.quantity)
      }
    },
  },
  computed: {
    changeHandler: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', this.quantity)
      },
    },
  },
}
</script>

<template>
  <div class="d-flex">
    <div class="spinner">
      <div class="spinnerBotton">
        <div @click="Increment" class="spinnerButtonColor1">
          <span class="my-auto">+</span>
        </div>
        <div @click="Decrement" class="spinnerButtonColor2">
          <span class="my-auto">-</span>
        </div>
      </div>
      <input v-model="changeHandler" class="spinnerInput" type="number" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner {
  position: relative;
  width: 100%;
}
.spinnerBotton {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
}
.spinnerButtonColor1 {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 16px;
  background: #556ee6;
  border-radius: 4px 4px 0 0;
  color: white;
}
.spinnerButtonColor2 {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 16px;
  background: #556ee6;
  border-radius: 0 0 4px 4px;
  color: white;
}
.spinnerInput {
  padding: 7px;
  direction: ltr;
  text-align: left;
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  height: 32px;
}
</style>
